// src/components/onboarding/OnboardingStep.js

import React from 'react';
import './Onboarding.css'; // Shared CSS for the entire flow

// This component is a wrapper that displays the question and renders the specific input control (children)
const OnboardingStep = ({ stepNumber, title, children, onNext, onBack, isFirstStep, isLastStep }) => {
  return (
    <div className="onboarding-step glossy-card">
      
      {/* Step Indicator */}
      <div className="step-indicator">
        Step **{stepNumber}**
      </div>

      {/* Question Title */}
      <h2 className="step-title">
        {title}
      </h2>

      {/* Input Area (Children will be the specific controls: buttons, sliders, etc.) */}
      <div className="step-content">
        {children}
      </div>

      {/* Navigation Controls */}
      <div className="step-navigation">
        <button 
          onClick={onBack} 
          disabled={isFirstStep}
          className="btn-secondary nav-btn back-btn"
        >
          &larr; Back
        </button>

        <button 
          onClick={onNext} 
          disabled={false} // Will be updated later to check if input is valid
          className="btn-primary nav-btn next-btn"
        >
          {isLastStep ? 'View Results' : 'Next Step →'}
        </button>
      </div>
    </div>
  );
};

export default OnboardingStep;
